import { createContext } from "react";

const ShippingMasterContext = createContext({});

export default ShippingMasterContext;
